import { $api } from "../generated/client";

type UseGiftCodesQueryOptions = {
  shopId: string;
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: "createdAt" | "usedAt";
  sortOrder?: "asc" | "desc";
  fromTimestamp?: number;
  toTimestamp?: number;
};

export default function useGiftCodes({
  shopId,
  page = 1,
  pageSize = 15,
  search,
  sortBy,
  sortOrder,
  fromTimestamp,
  toTimestamp,
}: UseGiftCodesQueryOptions) {
  return $api.useQuery("get", "/shops/{shopId}/gift-codes", {
    params: {
      path: { shopId },
      query: {
        page,
        pageSize,
        search: search || undefined,
        sortBy,
        sortOrder,
        fromTimestamp,
        toTimestamp,
      },
    },
  });
}
